import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {InputTextModule} from "primeng/inputtext";
import {ConfirmationService, MessageService} from "primeng/api";
import {Table, TableModule} from "primeng/table";
import {Button, ButtonDirective} from "primeng/button";
import {CardModule} from "primeng/card";
import {NgIf, NgTemplateOutlet} from "@angular/common";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {RouterLinkActive} from "@angular/router";
import {ToastModule} from "primeng/toast";
import {BadgeModule} from "primeng/badge";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {InputNumberModule} from "primeng/inputnumber";
import {MenuModule} from "primeng/menu";
import {TagModule} from "primeng/tag";
import {ToolbarModule} from "primeng/toolbar";
import {TooltipModule} from "primeng/tooltip";
import {
    UsuarioDialogComponent
} from "../../../users/mnto-usuarios/components/usuarios/usuario-dialog/usuario-dialog.component";
import {SharedModule} from "../../shared.module";
import {DialogModule} from "primeng/dialog";
import {DropdownModule} from "primeng/dropdown";
import {Ripple} from "primeng/ripple";
import {KeyFilterModule} from "primeng/keyfilter";
import {DashboardComponent} from "../../../officials/autorizaciones/components/dashboard/dashboard.component";
import {DialogService} from "primeng/dynamicdialog";
import {PersonasService} from "../../services/personas-service";
import {AutorizacionesService} from "../../../officials/autorizaciones/services/autorizaciones.service";
import {LoginServices} from "../../../auth/login/services/login.service";

import {Contacto,PersonaInfo,TipoAutorizaciones} from "../../interfaces/shared-interface";
import { UsuarioCorreoReq, UsuariosInterface } from 'src/app/users/mnto-usuarios/interfaces/usuarios.interface';
import { EditarPerfilComponent } from 'src/app/users/mnto-usuarios/components/usuarios/editar-perfil/editar-perfil.component';
import Swal from 'sweetalert2';
import { UsuariosService } from 'src/app/users/mnto-usuarios/Services/usuarios.service';
import { Persona } from 'src/app/auth/register/interfaces/tipos';
import { RegistroService } from 'src/app/auth/register/services/registro-service';
import { co } from '@fullcalendar/core/internal-common';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
    selector: 'app-personas-table',
    standalone: true,
    imports: [
        ButtonDirective,
        CardModule,
        NgIf,
        ProgressSpinnerModule,
        RouterLinkActive,
        ToastModule,
        BadgeModule,
        Button,
        ConfirmPopupModule,
        InputNumberModule,
        InputTextModule,
        MenuModule,
        TableModule,
        TagModule,
        ToolbarModule,
        TooltipModule,
        UsuarioDialogComponent,
        SharedModule,
        DialogModule,
        DropdownModule,
        Ripple,
        NgTemplateOutlet,
        KeyFilterModule,
        DashboardComponent,
        EditarPerfilComponent
    ],
    providers: [ConfirmationService, DialogService, MessageService],
    templateUrl: './personas-table.component.html',
    styleUrl: './personas-table.component.scss'
})
export class PersonasTableComponent implements OnInit {
    @Input() textCurrentPageTable: string = "";
    @Input() textCaption: string = "";
    @Input() filterByTypes: number [] = [];
    @Output() editarPerfil = new EventEmitter<UsuariosInterface>();
    mostrarUsuarioDialog = signal(false);
    correoPersona: string | undefined = undefined;
    idTipoPersona!: number | undefined | null;
    persona: PersonaInfo | null = null;
    _showLoader: boolean = true;
    tipos:number=0;
    cols: any[] = [];
    protected readonly TipoAutorizaciones = TipoAutorizaciones;

    constructor(public personasService: PersonasService, protected autorizacionesService: AutorizacionesService, protected loginServices: LoginServices, public usuarioService: UsuariosService, private registroService: RegistroService) {}

    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.getConsultaAutorizaciones(this.filterByTypes);
    }

    getConsultaAutorizaciones(tipos:number[]) {
        if(tipos.length==0){
            console.error("tipos no debe ser nulo o cero")
            return;
        }
        this.autorizacionesService.tipoAutorizacion.set(tipos);
        this.autorizacionesService.consultaAutorizaciones(this.loginServices.session()?.perfil?.uniqueId!,tipos)
            .subscribe(resp => {
                if (resp) {
                    this.autorizacionesService._autorizacionesPersona.set(resp!.body!);
                    this._showLoader=false;
                }
            });
    }

    autorizacionFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

    tagStyle(estado: number) {
        switch (estado) {
            case 1:
                return {background: '#28a745'};
            case 0:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }

    findContactoByTipo(contactos: Contacto[], tipo: string): Contacto | undefined {
        return contactos.find(contacto => contacto.tipo === tipo);
    }

    ngOnDestroy(): void {
        this.autorizacionesService._autorizacionesPersona.set([])
    }

    onEditarPerfil(usuario: PersonaInfo) {
        const correo = this.findContactoByTipo(usuario.contactos, "EMAIL")?.contacto;
        this.correoPersona = correo;
        this.idTipoPersona = usuario.idTipoPersona;
        this.persona = usuario;
        this.mostrarUsuarioDialog.set(true);
    }

    cerrarUsuarioDialog() {
        this.mostrarUsuarioDialog.set(false);
        this.correoPersona = undefined;
    }
    
    guardarCambiosPerfil(datos: { nombres: string, apellidos: string, correo: string }) {
        const correoNuevo = datos.correo?.trim() || '';
        const nombresNuevos = datos.nombres?.trim().toUpperCase() || '';
        const apellidosNuevos = datos.apellidos?.trim().toUpperCase() || '';

        if (correoNuevo === '') {
            Swal.fire("Datos incompletos", "Debe introducir un correo válido", "warning");
            this.cerrarUsuarioDialog();
            return;
        }

        if (this.idTipoPersona === 2 && nombresNuevos === '') {
            Swal.fire("Datos incompletos", "Debe introducir un nombre válido", "warning");
            this.cerrarUsuarioDialog();
            return;
        }

        if (this.idTipoPersona === 1 && (nombresNuevos === '' || apellidosNuevos === '')) {
            Swal.fire("Datos incompletos", "Debe introducir los nombres y apellidos", "warning");
            this.cerrarUsuarioDialog();
            return;
        }

        const observables = [];
        let errors = 0;
        
        if (correoNuevo !== this.correoPersona) {
            const payloadCorreo: UsuarioCorreoReq = {
                uniqueId: this.persona!.uniqueId,
                correoNuevo: datos.correo
            };

            const correo$ = this.usuarioService.actualizarCorreo(payloadCorreo).pipe(
                catchError(err => {
                    this.cerrarUsuarioDialog();
                    errors += 1;
                    if(err.error.mensaje === "Error el uniqueId es invalido para realizar el proceso de actualizar correo") {
                        return Swal.fire("Atención", "El correo del titular no puede ser actualizado debido a que no cuenta con un usuario", "warning");
                    } 
                    return Swal.fire("Error", err.error.mensaje, "error");
                })
            );
            
            observables.push(correo$);
        }
        
        const nombresCambio = nombresNuevos !== this.persona?.nombres;
        const apellidosCambio = apellidosNuevos !== this.persona?.apellidos;

        if ((this.idTipoPersona === 1 && (nombresCambio || apellidosCambio)) ||
            (this.idTipoPersona === 2 && nombresCambio)) {

            const payload: Persona = {
                nombres: nombresNuevos,
                apellidos: apellidosNuevos,
                idTipoPersona: Number(this.idTipoPersona),
                uniqueIdPersona: this.persona!.uniqueId,
                session: {
                    uniqueId: this.persona!.uniqueId,
                    usuario: "",
                    documento: "",
                    correo: "",
                }
            };

            const nombre$ = this.registroService.editarPerfil(payload).pipe(
                tap(() => {
                    const usuarioLogueadoId = this.loginServices.session()?.perfil?.uniqueId;
                    if (this.persona!.uniqueId === usuarioLogueadoId) {
                        this.loginServices.session.update(current => {
                            if (!current) return null;
                            return {
                                ...current,
                                perfil: {
                                    ...current.perfil,
                                    nombres: nombresNuevos,
                                    apellidos: apellidosNuevos,
                                    nombreCompleto: `${nombresNuevos} ${apellidosNuevos}`
                                }
                            };
                        });
                    }
                }),
                catchError(err => {
                    this.cerrarUsuarioDialog();
                    errors += 1;
                    return Swal.fire("Error", err.error.mensaje, "error");
                })
            );

            observables.push(nombre$);
        }

        forkJoin(observables).subscribe(resultados => {
            if (errors === 0) {
                Swal.fire("Éxito", "El titular se actualizó exitosamente.", "success");   
            }

            this.getConsultaAutorizaciones(this.filterByTypes); 
            this.cerrarUsuarioDialog();
        });
    }
}